import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
export function Objections() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  const objections = ['Experiencia', 'Mucho dinero', 'Ser experta en tecnología'];
  return <section className="bg-brand-beige py-20 px-6" data-id="element-182">
      <div className="max-w-3xl mx-auto text-center" data-id="element-183">
        <FadeIn data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-12" data-id="element-185">
            No necesitas:
          </h2>
        </FadeIn>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-16" data-id="element-186">
          {objections.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-187">
              <div className="bg-white px-8 py-4 rounded-full shadow-sm flex items-center justify-center gap-3 border border-brand-green/5" data-id="element-188">
                <div className="bg-red-50 rounded-full p-1" data-id="element-189">
                  <X className="w-5 h-5 text-red-500" data-id="element-190" />
                </div>
                <span className="text-lg font-medium text-brand-text" data-id="element-191">
                  {item}
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-192">
          <p className="text-2xl font-serif text-brand-green mb-10 flex items-center justify-center gap-3" data-id="element-193">
            <span data-id="element-194">👉</span> Solo necesitas empezar con una guía clara
          </p>
          <Button onClick={goToCheckout} data-id="element-195">SÍ, QUIERO EMPEZAR</Button>
        </FadeIn>
      </div>
    </section>;
}